import BaseCrmEntity from "../base-crm-entity";

class PortalUserEntity extends BaseCrmEntity {
  static entityName="faraz_portaluser";
  static entityPluralName="faraz_portalusers";
  static fields = {
    "entityimage":"entityimage",
    "faraz_displayname":"faraz_displayname",
    "faraz_username":"faraz_username",
    "faraz_account":"faraz_account",
    "faraz_portaluserid":"faraz_portaluserid",
    }
  constructor() {
    super(`${PortalUserEntity.entityName}`,`${PortalUserEntity.entityPluralName}`);
  }

  async getAll() {
    const fetchXml = `
      <fetch>
        <entity name="${PortalUserEntity.entityName}">
           ${Object.keys(PortalUserEntity.fields).map((attr)=>(`<attribute name="${attr}" />`)).join("")}
        </entity>
      </fetch>
    `;
    return await this.fetch(fetchXml);
  }
}

export default PortalUserEntity;
